import React from 'react';
import { Link } from 'react-router-dom';

export default (props) => {
  const{ margin, text, textLink, linkTo } =props;
  let empty;
  if(linkTo == '') empty = true;
  else empty = true;

  return (
    <section className="thirdSection" style={{  marginTop: 15  }}>
      <div className="horizontal-layout">
        <div className="line-horizontal" style={{margin:'0 8px' }}></div>
      </div>
      <div className="footer-card" style={{margin: margin }}>
        <p className="text-gray" style={{ margin: 0 }}>
          {text}{' '}
          <span className="text-link">
            { empty ? <a>{textLink}</a>: <Link to={linkTo}>{textLink}</Link>}
          </span>
        </p>
      </div>
    </section>
  );
};
